// Unpublished Work © 2020-2025 Deere & Company.

import {postError} from '../services/error';

export const logUiErrors: OnErrorEventHandlerNonNull = (
    event,
    source,
    lineno,
    colno,
    error,
) => {
    if (typeof event === 'string' && event.includes('ResizeObserver')) {
        return false;
    }

    postError(event, error, {
        url: source,
        lineNumber: lineno,
        columnNumber: colno,
    }).catch(console.error);

    return false;
};
